import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'vpfa-skew-line',
  templateUrl: './skew-line.component.html',
  styleUrls: ['./skew-line.component.scss'],
})
export class SkewLineComponent {}
